import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { NAV } from "@/lib/brand";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleY = useSpring(scrollYProgress, { stiffness: 90, damping: 24, mass: 0.4 });
  const [current, setCurrent] = useState("");

  useEffect(() => {
    const onScroll = () => {
      let active = "";
      for (const { id } of NAV) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.45) active = id;
      }
      setCurrent(active);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div
      data-testid="scroll-progress"
      className="hidden lg:flex fixed left-7 top-1/2 -translate-y-1/2 z-[60] flex-col items-center gap-5 group"
    >
      <div className="relative h-[38vh] w-px overflow-hidden" style={{ background: "rgba(196,166,113,0.22)" }}>
        <motion.div
          data-testid="scroll-progress-fill"
          className="absolute top-0 left-0 w-full origin-top"
          style={{ scaleY, height: "100%", background: "#C4A671" }}
        />
      </div>

      <div className="flex flex-col items-center gap-3">
        {NAV.map(({ id, label }) => (
          <button
            key={id}
            data-testid={`scroll-dot-${id}`}
            onClick={() => go(id)}
            aria-label={label}
            className="relative flex items-center"
          >
            <span
              className="block rounded-full transition-all duration-500"
              style={{
                width: current === id ? 7 : 4,
                height: current === id ? 7 : 4,
                background: current === id ? "#C4A671" : "rgba(196,166,113,0.35)",
                boxShadow: current === id ? "0 0 8px rgba(196,166,113,0.6)" : "none",
              }}
            />
            <span
              className="absolute left-5 whitespace-nowrap overline text-[8.5px] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400 pointer-events-none"
              style={{ color: current === id ? "#C4A671" : "#8a8578" }}
            >
              {label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
